import _ from 'lodash';
import { createUserSavedCharacteristic } from './user-saved-characteristics';
import { createUserSavedReturn } from './user-saved-returns';

export async function createMultipleUserSaved(validList) {
  let invalidNames = [];

  const charsResult = await Promise.allSettled(
    validList.map(({ name, currency, symbol, type, jurisdiction, category, subCategory }) =>
      createUserSavedCharacteristic(name, {
        currency,
        symbol,
        type,
        jurisdiction,
        category,
        subCategory,
      }),
    ),
  );

  charsResult.forEach((v, i) => v.status === 'rejected' && invalidNames.push(validList[i].name));

  const retResult = await Promise.allSettled(
    validList.map(({ name, dates, returns }) =>
      createUserSavedReturn(name, {
        dates,
        returns,
      }),
    ),
  );

  retResult.forEach((v, i) => v.status === 'rejected' && invalidNames.push(validList[i].name));

  invalidNames = _.uniq(invalidNames);

  if (invalidNames.length > 0) {
    throw Error(`Invalid Entry ${invalidNames.join(', ')}`);
  }

  return true;
}
